module.exports = __webpack_public_path__ + "img/194.578f1fcb.jpg";